import { IconEye, IconEyeOff } from "@tabler/icons-react";
import { forwardRef, useMemo, useState } from "react";
import { InputProps } from './types';

const Input = forwardRef<HTMLInputElement, InputProps>(({
    className,
    style,
    size,
    id,
    label,
    name,
    type = 'text',
    value = '',
    placeholder,
    onChange,
    onClick,
    error,
    ...props
}: InputProps, ref) => {

    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const classes = useMemo(() => {
        return [
            'form-control',
            size && `form-control-${size}`,
            error && 'is-invalid',
            className
        ].filter(Boolean).join(' ');
    }, [className, size, error]);

    const inputType = useMemo(() => (type === 'password' && !showPassword ? 'password' : 'text'), [type, showPassword]);

    return (
        <>
            {label && <label htmlFor={id}>{label}</label>}
            <div>
                <input
                    {...props}
                    ref={ref}
                    type={inputType} 
                    id={id}
                    name={name}
                    placeholder={placeholder}
                    style={style}
                    onClick={onClick ? onClick : undefined}
                    value={value}
                    onChange={onChange}
                    className={classes}
                />
                {type === 'password' && (
                    <span className="input-group-text" onClick={togglePasswordVisibility} role="button">
                        {showPassword ? (
                            <IconEyeOff
                                stroke="currentColor"
                                strokeWidth={2}
                                fill="none"
                                size={24}
                                className="icon icon-1"
                            />
                        ) : (
                            <IconEye
                                stroke="currentColor"
                                strokeWidth={2}
                                fill="none"
                                size={24}
                                className="icon icon-1"
                            />
                        )}
                    </span>
                )}
            </div>
        </>
    );
});

export default Input;
